import React from 'react';

interface TikTokLogoProps {
  className?: string;
}

const TikTokLogo: React.FC<TikTokLogoProps> = ({ className = '' }) => {
  return (
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g>
        <path 
          d="M12.53.02C13.84 0 15.14.01 16.44.02c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" 
          fill="#000000"
        />
        <path 
          d="M12.53.02c0 4.03-.03 8.05-.02 12.07-.01 1.79.03 3.58-.07 5.36-.01.39-.22.73-.41 1.06-.58.95-1.65 1.6-2.77 1.61-1.68.15-3.26-1.23-3.5-2.87-.01-.54-.07-1.1.14-1.61.25-.71.73-1.34 1.36-1.75.87-.6 2.03-.69 3.02-.37 0-1.48.06-2.96.04-4.44-2.17-.41-4.49.28-6.15 1.72-1.46 1.24-2.4 3.06-2.58 4.96-.02.49-.01.99.01 1.49.21 2.34 1.63 4.52 3.65 5.71 1.22.72 2.65 1.11 4.08 1.03 2.33-.04 4.6-1.29 5.91-3.21.81-1.15 1.27-2.54 1.35-3.94.03-2.91.01-5.83.02-8.75.52.34 1.05.67 1.62.93 1.31.62 2.76.92 4.2.97v-4.03c-1.54-.17-3.12-.68-4.24-1.79-1.12-1.08-1.67-2.64-1.75-4.17-1.3-.01-2.6-.02-3.91 0z" 
          fill="#EE1D52"
        />
        <path 
          d="M12.53.02c1.31-.02 2.61-.01 3.91 0-.08 1.53-.63 3.09-1.75 4.17-1.12 1.11-2.7 1.62-4.24 1.79v4.03c1.44-.05 2.89-.35 4.2-.97.57-.26 1.1-.59 1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" 
          fill="#FFFFFF"
          fillOpacity="0.5"
        />
        <path 
          d="M16.44.02c1.3-.01 2.6 0 3.9.02.03 1.53.48 3.11 1.58 4.28 1.11 1.22 2.78 1.75 4.38 1.81v4.04c-1.55-.05-3.1-.46-4.4-1.26-.35-.23-.69-.47-1.01-.74-.01 2.92.03 5.84-.02 8.75-.16 1.94-.93 3.81-2.21 5.22-1.18 1.28-2.8 2.12-4.51 2.32-1.63.15-3.28-.17-4.72-.98-1.92-1.12-3.37-3.16-3.72-5.38-.05-.48-.05-.96-.05-1.44.16-2.07 1.17-4.05 2.75-5.37 1.58-1.33 3.71-1.99 5.79-1.75.03 1.49 0 2.97 0 4.46-1.12-.25-2.39-.15-3.33.52-.72.47-1.25 1.21-1.46 2.04-.1.44-.08.91-.05 1.36.21 1.33 1.39 2.48 2.77 2.52 1.14.08 2.26-.59 2.79-1.57.27-.47.35-1.02.36-1.57.07-2.46.03-4.93.05-7.4-.01-3.36.01-6.73-.01-10.09z" 
          fill="#69C9D0"
          fillOpacity="0.7"
        />
      </g>
    </svg>
  );
};

export default TikTokLogo;
